import { PlusIcon, Rows3 } from "lucide-react";
import type { ModuleSectionNavItem } from "../../../components/navigation/ModuleSectionNav";

export const SCHOOL_CAMPS_SECTION_ITEMS: ModuleSectionNavItem[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    to: "/school/camps",
    end: true,
    icon: Rows3,
  },
  {
    id: "new",
    label: "New Camp",
    to: "/school/camps/new",
    icon: PlusIcon,
  },
];

